/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Bundle remove — delete all items sharing the same _rc_bundle ID
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-bundle-remove]');
    if (!btn) return;
    e.preventDefault();

    const bundleId = btn.getAttribute('data-bundle-remove');
    const bundleEl = btn.closest('[data-bundle-id]');
    if (bundleEl) bundleEl.classList.add('is-removed');

    // Collect all line item keys belonging to this bundle
    const children = document.querySelectorAll('[data-bundle-id="' + bundleId + '"] [data-item]');
    const updates = {};
    children.forEach(function (child) {
      updates[child.getAttribute('data-item')] = 0;
    });

    fetch(window.theme.routes.cart_url + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function () {
        // Use the theme's built-in cart refresh (rebuilds drawer + rebinds events)
        if (window.cart && typeof window.cart.getCart === 'function') {
          window.cart.getCart();
        }
      })
      .catch(function (err) {
        console.error('Bundle remove error:', err);
        if (bundleEl) bundleEl.classList.remove('is-removed');
      });
  });






  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
